import React from 'react';
import EventChatAvatarNode from './EventChatAvatarNode';

export function createEventAvatarRenderers({
  isNoteMessage,
  getAnnouncementToneClass,
  getAnnouncementIconClass,
  buildAssetUrl,
  appendVariant,
  adminImageRoot,
  artistImageRoot,
  personClassName = 'chat-avatar',
  clickableClassName = 'chat-avatar--clickable',
  initialClassName = 'chat-avatar-initial',
  announcementClassName = 'chat-avatar chat-avatar-announce',
  resolveArtistFallbackStyle,
}) {
  const renderAnnouncementAvatarLeft = (message) => {
    const toneClass = typeof getAnnouncementToneClass === 'function'
      ? getAnnouncementToneClass(message)
      : '';
    const iconClass = typeof getAnnouncementIconClass === 'function'
      ? getAnnouncementIconClass(message)
      : 'fa-bullhorn';
    return (
      <EventChatAvatarNode
        kind="announcement"
        title="お知らせ"
        announcementClassName={announcementClassName}
        announcementToneClassName={toneClass}
        announcementIconClass={`fa-solid ${iconClass}`}
      />
    );
  };

  const renderAdminAvatarLeft = (message, onClick) => {
    if (!message?.isAdminMsg) return null;
    if (typeof isNoteMessage === 'function' && isNoteMessage(message)) {
      return renderAnnouncementAvatarLeft(message);
    }
    return (
      <EventChatAvatarNode
        role="admin"
        name={message.admin_full_name || ''}
        picture={message.admin_profile_picture || ''}
        imageRoot={adminImageRoot}
        buildAssetUrl={buildAssetUrl}
        appendVariant={appendVariant}
        onClick={typeof onClick === 'function' ? onClick : undefined}
        className={personClassName}
        clickableClassName={clickableClassName}
        initialClassName={initialClassName}
      />
    );
  };

  const renderArtistAvatarLeft = (message, onClick) => {
    if (message?.isAdminMsg) return null;
    const fallbackStyle =
      typeof resolveArtistFallbackStyle === 'function'
        ? resolveArtistFallbackStyle(message)
        : null;
    return (
      <EventChatAvatarNode
        role="artist"
        name={message?.artist_name || ''}
        picture={message?.artist_profile_picture || ''}
        gender={message?.artist_gender || ''}
        imageRoot={artistImageRoot}
        buildAssetUrl={buildAssetUrl}
        appendVariant={appendVariant}
        onClick={typeof onClick === 'function' ? onClick : undefined}
        className={personClassName}
        clickableClassName={clickableClassName}
        initialClassName={initialClassName}
        fallbackStyle={fallbackStyle}
      />
    );
  };

  return {
    renderAnnouncementAvatarLeft,
    renderAdminAvatarLeft,
    renderArtistAvatarLeft,
  };
}
